import React, {useState} from 'react';
import styled from 'styled-components';
import {CONSTS}  from './_constants';
import {Link as RLink} from 'react-router-dom';

const Heading = ({className, h=1, children, style}) => (
    <>
        {h===1 && <h1 className={className}>{children}</h1>}
        {h===2 && <h2 className={className}>{children}</h2>}
        {h===3 && <h3 className={className}>{children}</h3>}
        {h===4 && <h4 className={className}>{children}</h4>}
        {h===5 && <h5 className={className}>{children}</h5>}
        {h===6 && <h6 className={className}>{children}</h6>}
    </>
);
export const Title = styled(Heading)`
    color: rgba(77, 76, 101, 1);
    ${props => props.primary && `color: ${CONSTS.colors.primary};`}
    ${props => props.center && `text-align: center;`}
    ${props => props.left && `text-align: left;`}
    ${props => props.right && `text-align: right;`}
    ${props => props.m0 && `margin: 0`}
`

const Anchor = ({className, to=null, href=null, onClick, children, style}) => {
    const props = {
        className,
        style,
        onClick
    }
    return(
        <>
            {to && <RLink {...props} to={to}>{children}</RLink>}
            {href && <a {...props} href={href}>{children}</a>}
        </>
    )
};
export const Link = styled(Anchor)`
    font-size: 14px;
    font-weight: 500;
    transition: color .2s;
    ${
        props => 
            props.light && `
                font-weight: lighter;
            `
    }
    ${
        props =>
            props.small && `
                font-size: 11px;
            `
    }
    ${
        props =>
            props.large && `
                font-size: 16px;
            `
    }
    ${props =>
        props.underline ? `` : `
            text-decoration: none;
        `
    }
    color: #333;
    &:hover{
        color: #000;
    }
    ${ props => 
        props.primary &&
        `
            color: ${CONSTS.colors.primary};
            &:hover{
                color: ${CONSTS.colors.primaryDark};
            }
        ` 
    }
    ${ props => 
        props.muted &&
        `
            color: rgba(211, 212, 218, 1);
            &:hover{
                color: #999;
            }
        ` 
    }
`;

export const Text = styled.p`
    margin: 0;
    color: #333;    
    ${props => {
        return (`
            ${props.muted ? `color: #ccc;` : ""}
            ${props.small ? `
                font-size: 12px;
                line-height: 15px;
            ` : `
                font-size: 14px;
                line-height: 20px;
            `}
            ${props.justify ? `
                text-align: justify;
            ` : ``}
            ${props.left ? `
                text-align: left;
            ` : ``}
            ${props.right ? `
                text-align: right;
            ` : ``}
            ${props.light ? `
                font-weight: lighter;
            ` : ``}
        `)
    }}
`;